import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconFaceDelighted = ({ size = 18, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
      <path d='M7 10.5a2 2 0 0 1 4 0M13 10.5a2 2 0 0 1 4 0' />
      <path d='M7.5 13.5h9a4.5 4.5 0 0 1-9 0z' fill='currentColor' />
    </g>
  </SDIcon>
)

export default IconFaceDelighted
